import { render } from "./recoverView.vue?vue&type=template&id=e64092fe&scoped=true"
import script from "./recoverView.vue?vue&type=script&lang=js"
export * from "./recoverView.vue?vue&type=script&lang=js"

import "./recoverView.vue?vue&type=style&index=0&id=e64092fe&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64092fe"]])

export default __exports__